import { render } from "./PolarAreaChart.vue?vue&type=template&id=4ab223ea"
import script from "./PolarAreaChart.vue?vue&type=script&lang=js"
export * from "./PolarAreaChart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__